import {createAction} from 'redux-actions';
import {getIngestStatusList} from '@pluto/rest';

export const INGEST_STATUSES_SET = 'INGEST_STATUSES_SET';

export const setIngestStatusesAction = createAction(INGEST_STATUSES_SET, async () => {
    return await getIngestStatusList();
});
